// Base Network Configuration
export const BASE_SEPOLIA = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'base-sepolia',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://sepolia.base.org'] },
    default: { http: ['https://sepolia.base.org'] },
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://sepolia.basescan.org' },
  },
  testnet: true,
} as const

export const BASE_MAINNET = {
  id: 8453,
  name: 'Base',
  network: 'base',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://mainnet.base.org'] },
    default: { http: ['https://mainnet.base.org'] },
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://basescan.org' },
  },
  testnet: false,
} as const

// BaseVibe Contract Address
// Automatically uses the correct address based on environment
const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === 'development'

export const CONTRACT_ADDRESS = isDevelopment
  ? (import.meta.env.VITE_CONTRACT_ADDRESS_SEPOLIA || '0x0000000000000000000000000000000000000000')
  : (import.meta.env.VITE_CONTRACT_ADDRESS_MAINNET || '0x0000000000000000000000000000000000000000')

// Export the current network for debugging
export const CURRENT_NETWORK = isDevelopment ? 'Base Sepolia (Testnet)' : 'Base Mainnet'

// Chain IDs for Base networks
export const BASE_SEPOLIA_CHAIN_ID = 84532
export const BASE_MAINNET_CHAIN_ID = 8453

// Export the expected chain ID based on environment
export const EXPECTED_CHAIN_ID = isDevelopment ? BASE_SEPOLIA_CHAIN_ID : BASE_MAINNET_CHAIN_ID
export const EXPECTED_CHAIN_NAME = isDevelopment ? 'Base Sepolia' : 'Base'

// Performance targets
export const PERFORMANCE_TARGETS = {
  LOAD_TIME_MS: 3000, // 3 seconds
  ACTION_TIME_MS: 1000, // 1 second
} as const

